import { changeBundleVariants } from '../slice/product.slice';

export const bundleVariantsUpdatedEvent = changeBundleVariants;
